import { FormattedMessage } from "react-intl";
import style from "./SignUpTodayBanner.module.scss";
import Logo from "nvent-web/assets/svg/logo-horizontal.svg";
import { getEmailByCountryCode } from "../../utils/getEmailByCountryCode";

export const SignUpTodayBanner = ({ countryCode }: { countryCode: string }) => {
  return (
    <div className={style.wrapper}>
      <img src={Logo} alt="Logo" className={style.logo} />
      <div className={style.content}>
        <h3 className={style.title}>
          <FormattedMessage id="certifiedPage.signUpToday.title" />
        </h3>
        <p className={style.description}>
          <FormattedMessage id="certifiedPage.signUpToday.description" />
        </p>
        <a
          href={`mailto:${getEmailByCountryCode(countryCode)}`}
          className={style.cta}
        >
          <FormattedMessage id="certifiedPage.signUpToday.button" />
        </a>
      </div>
    </div>
  );
};
